<template>
<div>
  <div class="header-steps">
    <strong>Etapa {{ nRootSteps }} de {{ nRootSteps }} - Resumo do combo</strong>
  </div>

  <div class="header-label">
    <div>
      <div style="font-size: 14px;">
        <i class="fa-regular fa-user" />&nbsp;&nbsp;
        <strong>{{ $props.nomeItem.toUpperCase() }}</strong>
      </div>
    </div>
  </div>
  <div
    v-for="price in prices"
    :key="price.id"
    class="faixa-option">
    <div class="faixa-option-info">
      <strong>{{ price.faixa_nome }}</strong><br>
      <span>({{ price.faixa_descricao }})</span><br>
      <span
        v-if="price.precoDe"
        style="color: lightgray; text-decoration: line-through;">{{ formatMoney(price.precoDe) }}&nbsp;</span>
      <strong :style="{color: primaryColor}">{{ formatMoney(price.preco) }}</strong>
    </div>
    <div
      class="faixa-option-quantity-display"
      translate="no">
      <strong>x{{ price.quantidade }}</strong>
    </div>
  </div>

  <div class="header-label mt-3">
    <div>
      <div style="font-size: 14px;">
        <i class="fas fa-shopping-bag" />&nbsp;&nbsp;
        <strong>ITENS DO COMBO</strong>
      </div>
    </div>
  </div>
  <div
    v-for="ac in activities"
    :key="ac.id"
    class="faixa-option">
    <div class="faixa-option-info">
      <strong>{{ ac.nome }}</strong><br>
      <span>{{ formatDate(ac.selectedDay) }} | {{ ac.selectedAvailability ? ac.selectedAvailability.label : '' }}</span><br>
    </div>
  </div>

  <div
    v-if="groupedOptionals.length > 0"
    class="header-label mt-3">
    <div>
      <div style="font-size: 14px;">
        <i class="fa-solid fa-star" />&nbsp;&nbsp;
        <strong>OPCIONAIS</strong>
      </div>
    </div>
  </div>
  <div
    v-for="op in groupedOptionals"
    :key="op.id"
    class="faixa-option">
    <div class="faixa-option-info">
      <strong>{{ op.nome }}</strong><br>
      <small>Para: {{ op.atividade }}</small><br>
      <strong :style="{color: primaryColor}">{{ formatMoney(op.preco) }}</strong>
    </div>
    <div
      class="faixa-option-quantity-display"
      translate="no">
      <strong>x{{ op.quantidade }}</strong>
    </div>
  </div>

  <div
    v-if="hasScheduleConflicts"
    class="alert alert-danger mt-2"
    role="alert">
    Os horários selecionados estão em conflito, verifique nas etapas anteriores.
  </div>
  
  <nav-buttons
    :style="{'margin-top': isMobile ? '0px' : '20px'}"
    :disable-previus="false"
    :disable-next="disableFinish"
    :is-finish="true"
    :is-mobile="isMobile"
    :moeda="moeda"
    :sub-total="subTotal"
    @next="finish"
    @previus="previus" />
</div>
</template>

<script>
import NavButtons from './NavButtons.vue';

export default {
    components: { NavButtons },
    props: {
        disableFinish: {
            type: Boolean,
            default: () => false,
            required: true
        },
        isMobile: {
            type: Boolean,
            default: () => false,
            required: false
        },
        prices: {
            type: Array,
            default: () => [],
            required: true
        },
        activities: {
            type: Array,
            default: () => [],
            required: true
        },
        nomeItem: {
            type: String,
            default: () => 'PESSOAS',
            required: true
        },
        primaryColor: {
            type: String,
            default: () => '#FF0000',
            required: true
        },
        moeda: {
            type: String,
            default: () => 'BRL',
            required: true
        },
        subTotal: {
            type: Number,
            default: () => 0,
            required: true
        },
        nRootSteps: {
            type: Number,
            default: () => 0,
            required: true
        },
        hasScheduleConflicts: {
            type: Boolean,
            default: () => false,
            required: true
        }
    },
    emits: ['finish', 'previus'],
    computed: {
        groupedOptionals() {
            const grouped = {};
            let i = 0;
            this.activities.forEach((ac) => {
                i++;
                ac.selectedOptionals.forEach((op) => {
                    if (!grouped[op.id]) {
                        grouped[op.id] = {};
                        grouped[op.id].quantidade = 0;
                        grouped[op.id].id = op.id;
                        grouped[op.id].nome = op.nome;
                        grouped[op.id].preco = op.preco;
                        grouped[op.id].atividade = ac.nome;
                        grouped[op.id].index = i;
                    }
                    grouped[op.id].quantidade += op.quantidade;
                });
            });
            const r = Object.values(grouped);
            return r.sort((a, b) => a.index - b.index);
        }
    },
    methods: {
        finish() {
            this.$emit('finish');
        },
        previus() {
            this.$emit('previus');
        },
        formatMoney(price) {
            let locale = 'pt-Br';

            if (this.$props.moeda === 'USD') {
                locale = 'en-US';
            }

            if(price <= 0 || price === null) {
                return 'Gratuito';
            }
            
            return Number(price).toLocaleString(locale, { style: 'currency', currency: this.$props.moeda });
        },
        formatDate(date) {
            if(!date) {
                return '';
            }
            return new Date(date).toLocaleDateString('pt-BR');
        }
    }
};
</script>

<style scoped>
.header-steps {
    font-size: 14px;
    margin-top: 10px;
    margin-bottom: 20px;
}
.header-label {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    border-bottom: 1px solid #707070;
}

.faixa-option {
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.faixa-option-info {
    line-height: 18px;
    font-size: 14px;
    width: 79%;
}

.faixa-option-quantity-display {
    width: 40px;
    height: 40px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    color: #464646;
}
</style>
